import { FC, useEffect } from "react";
import { TabType } from "../types/rentalCarDatesRangeInput.types";
import { useData } from "data/data-provider";
import { useLocation } from "react-router-dom";

const TabSwitcher: FC = () => {

  const { activeTab, setActiveTab, selectedCar, ourCompany } = useData();

  const location = useLocation();
  const isListingRoute =
    location.pathname === "/listing-car-detail" ||
    location.pathname === "/car-listing-detail";

  const maxDuration =
    selectedCar?.max_trip_duration === null
      ? Infinity
      : selectedCar?.max_trip_duration ?? 0;

  // Company-level rental mode flags (1NOW-977)
  const longTermEnabled = !!ourCompany?.allow_long_term_rentals;
  const hourlyEnabled = !!ourCompany?.allow_hourly_rentals;

  // Weeks / Months are long-term rental tabs — only show when the company
  // has long-term rentals enabled AND the fleet's max trip duration allows
  // it (the second constraint only applies on listing routes).
  const showWeeks =
    longTermEnabled && (isListingRoute ? maxDuration >= 7 : true);
  const showMonths =
    longTermEnabled && (isListingRoute ? maxDuration >= 30 : true);
  const showDates = isListingRoute ? maxDuration >= 7 : true;
  // Hours tab gated by the company-level allow_hourly_rentals flag.
  const showHours = hourlyEnabled;

  // Tab order per spec: Hours, Dates, Weeks, Months (Hours first when enabled)
  const tabs: TabType[] = [];
  if (showHours) tabs.push("hours");
  if (showDates) tabs.push("dates");
  if (showWeeks) tabs.push("weeks");
  if (showMonths) tabs.push("months");
  if (tabs.length === 0) tabs.push("dates");

  useEffect(() => {
    if (!tabs.includes(activeTab as TabType)) {
      setActiveTab(tabs[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs.join(","), activeTab, setActiveTab]);

  return tabs.length > 0 ? (
    <div className="flex justify-center mb-6">
      <div className="inline-flex bg-secondary-100 rounded-full p-1">
        {tabs.map((tab) => (
            <button
              key={tab}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab(tab);
              }}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all capitalize ${
                activeTab === tab
                  ? "bg-primary-200 hover:bg-primary-700 text-on-primary shadow-sm"
                  : "text-secondary-text-color hover:text-text-color"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
  ) : null;
};

export default TabSwitcher;
